import React from 'react';
import { Tag, Tooltip } from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

interface PageVersionActiveStatusProps {
    isActive: boolean;
}

const PageVersionActiveStatus: React.FC<PageVersionActiveStatusProps> = ({ isActive }) => {
    const tagColor = isActive ? 'success' : 'default';

    const tagIcon = isActive ? (
        <CheckCircleOutlined />
    ) : (
        <CloseCircleOutlined />
    );

    const tooltip = isActive
        ? 'This page version is currently active and in use.'
        : 'This page version is inactive and not being used.';

    const label = isActive ? 'active' : 'inactive';

    return (
        <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tooltip title={tooltip} color="purple">
                <Tag
                    bordered
                    color={tagColor}
                    icon={tagIcon}
                    style={{ marginLeft: '2px' }}
                >
                    {label}
                </Tag>
            </Tooltip>
        </span>
    );
};

export default PageVersionActiveStatus;